import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchHotelRateSettings,
  HotelRateSettingsResponse,
} from "@/services/hotel-rate-settings.service";

interface HotelRateSettingsState {
  data: HotelRateSettingsResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: HotelRateSettingsState = {
  data: null,
  loading: false,
  error: null,
};

export const getHotelRateSettings = createAsyncThunk(
  "hotelRateSettings/fetch",
  async ({ hotelId, baseValue }: { hotelId: number; baseValue: number }) => {
    return await fetchHotelRateSettings(hotelId, baseValue);
  }
);

const hotelRateSettingsSlice = createSlice({
  name: "hotelRateSettings",
  initialState,
  reducers: {
    clearRateSettings: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHotelRateSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHotelRateSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getHotelRateSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch rate settings";
      });
  },
});

export const { clearRateSettings } = hotelRateSettingsSlice.actions;
export default hotelRateSettingsSlice.reducer;
